import { render, staticRenderFns } from "./storageLocation.vue?vue&type=template&id=30e4cfc8&scoped=true"
import script from "./storageLocation.vue?vue&type=script&lang=js"
export * from "./storageLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4cfc8",
  null
  
)

export default component.exports